import { TableViewColumnDefinition } from '@components/UI-Components/StandardTableView/models/TableViewColumnDefinition'
import { clientOrderManagementTableViewColumnIdentifiers } from '@modules/common/models/enums/ClientOrderManagementTableViewColumnIdentifiers'
import { clientOrderManagementTableViewColumnLabel } from '@modules/common/models/enums/ClientOrderManagementTableViewColumnLabel'
import { ColumnWidth } from '@modules/common/models/enums/ColumnWidth'
import { clientOrderManagementTableFieldViewMapping } from '@modules/common/models/enums/OrderManagementTableFieldViewMapping'
import { TextAlignment } from '@modules/common/models/enums/TextAlignment'
import { orderManagementComponentService } from '@modules/wholesale/orderManagement/container/OrderManagementComponentService'
import { cancelProductComponentService } from '../container/CancelProductComponentService'
import * as css from '../component/styles.css'

export enum selectionTotalColumnLabel {
  selectionTotals = 'Totals',
  current = 'Current',
  cancelled = 'Cancelled',
  retail = 'Retail',
  wholesale = 'Wholesale'
}

export enum selectionTotalColumnIdentifiers {
  selectionTotals = 'selectionTotals',
  current = 'current',
  cancelled = 'cancelled',
  retail = 'retail',
  wholesale = 'wholesale'
}

export enum selectionTotalFieldMapping {
  selectionTotals = 'selectionTotals',
  current = 'current',
  cancelled = 'cancelled',
  retail = 'retail',
  wholesale = 'wholesale'
}

class ProductOrderTableDefinitionService {
  buildTableViewDefinitionForProductOrder = (
    isGMOrAdmin: boolean,
    isRTLOrderView: boolean
  ) => {
    const clientName = new TableViewColumnDefinition({
      id: isRTLOrderView
        ? clientOrderManagementTableViewColumnIdentifiers.zoneName
        : clientOrderManagementTableViewColumnIdentifiers.clientName,
      isFixed: true,
      width: ColumnWidth.Medium,
      header: {
        label: isRTLOrderView
          ? clientOrderManagementTableViewColumnLabel.zoneName
          : clientOrderManagementTableViewColumnLabel.ClientName
      },
      props: {
        fontSize: 'Bold 12px Roboto'
      },
      node: {
        key: clientOrderManagementTableFieldViewMapping.ClientName,
        labelKey: isRTLOrderView
          ? clientOrderManagementTableFieldViewMapping.ZoneName
          : clientOrderManagementTableFieldViewMapping.ClientName,
        disableKey: clientOrderManagementTableFieldViewMapping.ClientDisabled,
        component: orderManagementComponentService.getLabelComponent
      },
      showColumnFilter: true
    })
    const clientCode = new TableViewColumnDefinition({
      id: isRTLOrderView
        ? clientOrderManagementTableViewColumnIdentifiers.zoneCode
        : clientOrderManagementTableViewColumnIdentifiers.clientCode,
      isFixed: true,
      width: ColumnWidth.Medium,
      header: {
        label: isRTLOrderView
          ? clientOrderManagementTableViewColumnLabel.zoneCode
          : clientOrderManagementTableViewColumnLabel.clientCode
      },
      node: {
        key: clientOrderManagementTableFieldViewMapping.ClientCode,
        labelKey: isRTLOrderView
          ? clientOrderManagementTableFieldViewMapping.ZoneCode
          : clientOrderManagementTableFieldViewMapping.ClientCode,
        component: orderManagementComponentService.getLabelComponent
      },
      showColumnFilter: true
    })
    const order = new TableViewColumnDefinition({
      id: clientOrderManagementTableViewColumnIdentifiers.order,
      isFixed: true,
      width: ColumnWidth.Large,
      header: {
        label: clientOrderManagementTableViewColumnLabel.order
      },
      props: {
        fontSize: 'bold var(--typography-body3)'
      },
      node: {
        key: clientOrderManagementTableFieldViewMapping.OrderNumber,
        component: orderManagementComponentService.getLabelComponent // read-only
      },
      showColumnFilter: true
    })
    const country = new TableViewColumnDefinition({
      id: clientOrderManagementTableViewColumnIdentifiers.country,
      width: ColumnWidth.Small,
      header: {
        label: clientOrderManagementTableViewColumnLabel.country
      },
      node: {
        key: clientOrderManagementTableFieldViewMapping.Country,
        component: orderManagementComponentService.getLabelComponent
      },
      showColumnFilter: true
    })
    const doors = new TableViewColumnDefinition({
      id: isRTLOrderView
        ? clientOrderManagementTableViewColumnIdentifiers.stores
        : clientOrderManagementTableViewColumnIdentifiers.doors,
      width: ColumnWidth.Medium,
      props: {
        cellPadding: '0px'
      },
      header: {
        label: isRTLOrderView
          ? clientOrderManagementTableViewColumnLabel.stores
          : clientOrderManagementTableViewColumnLabel.doors
      },
      node: {
        key: clientOrderManagementTableFieldViewMapping.Doors,
        labelKey: isRTLOrderView
          ? clientOrderManagementTableFieldViewMapping.Stores
          : clientOrderManagementTableFieldViewMapping.Doors,
        component: orderManagementComponentService.getMenuComponent
      },
      showColumnFilter: true
    })
    const creationDate = new TableViewColumnDefinition({
      id: clientOrderManagementTableViewColumnIdentifiers.creationDate,
      width: ColumnWidth.Medium,
      header: {
        label: clientOrderManagementTableViewColumnLabel.creationDate
      },
      node: {
        key: clientOrderManagementTableFieldViewMapping.CreationDate,
        component: orderManagementComponentService.getLabelComponent
      },
      showColumnFilter: true
    })
    const globalValue = new TableViewColumnDefinition({
      id: clientOrderManagementTableViewColumnIdentifiers.globalValue,
      width: ColumnWidth.Medium,
      header: {
        label: clientOrderManagementTableViewColumnLabel.globalValue
      },
      node: {
        key: clientOrderManagementTableFieldViewMapping.globalValue,
        component: orderManagementComponentService.getLabelComponent
      },
      showColumnFilter: true
    })
    const qty = new TableViewColumnDefinition({
      id: clientOrderManagementTableViewColumnIdentifiers.qty,
      width: ColumnWidth.XS,
      header: {
        label: clientOrderManagementTableViewColumnLabel.qty
      },
      props: {
        alignment: TextAlignment.right
      },
      node: {
        key: clientOrderManagementTableFieldViewMapping.Qty,
        component: orderManagementComponentService.getLabelComponent
      },
      showColumnFilter: true
    })
    const status = new TableViewColumnDefinition({
      id: clientOrderManagementTableViewColumnIdentifiers.status,
      width: ColumnWidth.Status,
      header: {
        label: clientOrderManagementTableViewColumnLabel.status
      },
      node: {
        key: clientOrderManagementTableFieldViewMapping.Status,
        disableKey: clientOrderManagementTableFieldViewMapping.IsEditStatusDisabled,
        component: orderManagementComponentService.getLabelComponent
      },
      showColumnFilter: true
    })
    return isRTLOrderView
      ? [
          clientName,
          clientCode,
          order,
          country,
          doors,
          creationDate,
          globalValue,
          qty,
          status
        ]
      : [
          clientName,
          clientCode,
          order,
          country,
          doors,
          creationDate,
          new TableViewColumnDefinition({
            id: clientOrderManagementTableViewColumnIdentifiers.zam,
            width: ColumnWidth.Medium,
            header: {
              label: clientOrderManagementTableViewColumnLabel.zam
            },
            node: {
              key: clientOrderManagementTableFieldViewMapping.ZAM,
              component: orderManagementComponentService.getLabelComponent
            },
            showColumnFilter: true
          }),
          new TableViewColumnDefinition({
            id: clientOrderManagementTableViewColumnIdentifiers.salesAsst,
            width: ColumnWidth.Medium,
            header: {
              label: clientOrderManagementTableViewColumnLabel.salesAsst
            },
            node: {
              key: clientOrderManagementTableFieldViewMapping.SalesAssistant,
              component: orderManagementComponentService.getLabelComponent
            },
            showColumnFilter: true
          }),
          globalValue,
          qty,
          status,
          new TableViewColumnDefinition({
            id: clientOrderManagementTableViewColumnIdentifiers.sapStatus,
            width: ColumnWidth.Medium,
            props: {
              alignment: TextAlignment.center,
              cellPadding: '0px'
            },
            header: {
              label: clientOrderManagementTableViewColumnLabel.sapStatus,
              action: isGMOrAdmin && {
                component:
                  orderManagementComponentService.getOrderManagementBulkStatusComponentForOpen
              }
            },
            node: {
              key: clientOrderManagementTableFieldViewMapping.SAPStatus,
              disableKey: clientOrderManagementTableFieldViewMapping.IsSendToSAPDisabled,
              component: orderManagementComponentService.getSendToSAPComponent
            },
            showColumnFilter: true
          })
        ]
  }

  buildColDefinitionForSelectionTotal = () => {
    return [
      new TableViewColumnDefinition({
        id: selectionTotalColumnIdentifiers.selectionTotals,
        width: ColumnWidth.Large,
        header: {
          label: selectionTotalColumnLabel.selectionTotals,
          className: css.customHeaderBold
        },
        node: {
          key: selectionTotalFieldMapping.selectionTotals,
          component: cancelProductComponentService.getBoldLabelComponent
        },
        showColumnFilter: false
      }),
      new TableViewColumnDefinition({
        id: selectionTotalColumnIdentifiers.current,
        width: ColumnWidth.OrderTotal,
        header: {
          label: selectionTotalColumnLabel.current,
          className: css.customHeaderNormal
        },
        node: {
          key: selectionTotalFieldMapping.current,
          component: cancelProductComponentService.getBoldLabelComponent
        },
        showColumnFilter: false
      }),
      new TableViewColumnDefinition({
        id: selectionTotalColumnIdentifiers.cancelled,
        width: ColumnWidth.OrderTotal,
        header: {
          label: selectionTotalColumnLabel.cancelled,
          className: css.customHeaderNormal
        },
        node: {
          key: selectionTotalFieldMapping.cancelled,
          component: cancelProductComponentService.getBoldLabelComponent
        },
        showColumnFilter: false
      })
    ]
  }

  buildColDefinitionForRetailTotal = () => {
    return [
      new TableViewColumnDefinition({
        id: selectionTotalColumnIdentifiers.retail,
        width: ColumnWidth.Medium,
        header: {
          label: selectionTotalColumnLabel.retail,
          className: css.customHeader
        },
        node: {
          key: selectionTotalFieldMapping.retail,
          component: cancelProductComponentService.getLabelComponent
        },
        showColumnFilter: false
      }),
      new TableViewColumnDefinition({
        id: selectionTotalColumnIdentifiers.current,
        width: ColumnWidth.OrderTotal,
        header: {
          label: selectionTotalColumnLabel.current,
          className: css.customHeaderNormal
        },
        node: {
          key: selectionTotalFieldMapping.current,
          component: cancelProductComponentService.getLabelComponent
        },
        showColumnFilter: false
      }),
      new TableViewColumnDefinition({
        id: selectionTotalColumnIdentifiers.cancelled,
        width: ColumnWidth.OrderTotal,
        header: {
          label: selectionTotalColumnLabel.cancelled,
          className: css.customHeaderNormal
        },
        node: {
          key: selectionTotalFieldMapping.cancelled,
          component: cancelProductComponentService.getLabelComponent
        },
        showColumnFilter: false
      })
    ]
  }

  buildColDefinitionForWholesaleTotal = () => {
    return [
      new TableViewColumnDefinition({
        id: selectionTotalColumnIdentifiers.wholesale,
        width: ColumnWidth.Medium,
        header: {
          label: selectionTotalColumnLabel.wholesale,
          className: css.customHeader
        },
        node: {
          key: selectionTotalFieldMapping.wholesale,
          component: cancelProductComponentService.getLabelComponent
        },
        showColumnFilter: false
      }),
      new TableViewColumnDefinition({
        id: selectionTotalColumnIdentifiers.current,
        width: ColumnWidth.OrderTotal,
        header: {
          label: selectionTotalColumnLabel.current,
          className: css.customHeaderNormal
        },
        node: {
          key: selectionTotalFieldMapping.current,
          component: cancelProductComponentService.getLabelComponent
        },
        showColumnFilter: false
      }),
      new TableViewColumnDefinition({
        id: selectionTotalColumnIdentifiers.cancelled,
        width: ColumnWidth.OrderTotal,
        header: {
          label: selectionTotalColumnLabel.cancelled,
          className: css.customHeaderNormal
        },
        node: {
          key: selectionTotalFieldMapping.cancelled,
          component: cancelProductComponentService.getLabelComponent
        },
        showColumnFilter: false
      })
    ]
  }
}

export const productOrderTableDefService = new ProductOrderTableDefinitionService()
